export const HEADER_HEIGHT = 116;
export const UNAUTHORIZED_HEADER_HEIGHT = 64;
export const MIGRATION_BANNER_HEIGHT = 36;
